<a
  [href]="url"
  [target]="target"
  class="med-external-link"
>
  <med-icon-trident
    *ngIf="showTrident"
    size="24"
    class="med-external-link__trident"
  ></med-icon-trident>

  <div class="med-external-link__text">
    <ng-content></ng-content>
  </div>

  <med-icon-arrow-up-right
    size="24"
    class="med-external-link__icon"
  ></med-icon-arrow-up-right>
</a>
